export default [
  {
    path: 'access-error',
    name: 'access-error',
    component: () => import('@/modules/auth/pages/AccessErrorPage.vue'),
    meta: {
      requiresAuth: true,
      icon: 'error',
    },
    children: [],
  },
];
